import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { useState, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import { useAddNewassetReqMutation } from '../../../features/assetrequest/assetReqApiSlice';
import { useGetUsersQuery } from '../../../features/users/usersApiSlice';
import useAuth from '../../../features/hooks/useAuth';
import { useGetAssetsFinalQuery, useUpdateAssetintransitMutation } from '../../../features/addassets/addassetfinalApiSlice';
import EnhancedTable from './OffToOffReqTable'
import { useGetofficesQuery } from '../../../features/offices/officesApiSlice';
import Select from 'react-select';
import TextField from '@mui/material/TextField';
import { useNavigate } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import {
    HeadingWrap, Span, CommonButton, PreDataWrap, IntReqWrapper,
    RequestClosureWarapperAccepted, RequestClosureWarapperRejected, AddRemarkButton, BackButtonSpan,
    ReqWrapper, StoreNameCont, ExtReqWrapper, PopupButton
} from '../../../Styles/CommonStyles'

const Container = styled.div``
const Wrapper = styled.div``
const SelectContainer = styled.div`
display: flex;
align-items: center;
margin-bottom: 25px;
`
const Option = styled.option`
font-weight: 100;
`
const Styledlabel = styled.label`
font-size: 20px;
font-weight: 200;
`
const StoreSelect = styled.select`
width: 30%;
height: 25px;
`
const OfficeSelect = styled.select`
width: 30%;
height: 35px;
`
const TextInputWrap = styled.div`
height: 30vh;
`
const SubmitButton = styled(CommonButton)`
`
const BoSpan = styled(CommonButton)`
border-radius: 0%;
background-color: #58427C;
`

const OffToOffReq = () => {

    const [content, setContent] = useState('');
    const editor = useRef(null);
    const [selectedOffice, setSelectedOffice] = useState()

    //created hook to pass data from ofcassettable to parent
    const [intSelected, setIntSelected] = useState([])

    //logged in user data
    const { id, email, designation, designationSuffix, numSuffix, roles } = useAuth()
    let user_current_office = (useSelector((state) => state.office.off))
    let user_current_role_array = roles[user_current_office]

    function handleSelect(data) {
        setSelectedOffice(data);
    }

    // all users call 
    const {
        data: usersdata,
        isLoading: usersLoading,

    } = useGetUsersQuery('userslist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let users = usersdata ? Object.values(usersdata?.entities) : []

    //usercall/single user call
    const { getSingleuser } = useGetUsersQuery('userslist', {
        selectFromResult: ({ data }) => ({
            getSingleuser: data?.entities
        }),
    })

    // all office call
    const {
        data: allofficedata,
        isLoading: allofficeLoad,
    } = useGetofficesQuery('officelist', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    });

    let tempallofficedata = allofficedata ? Object.values(allofficedata?.entities) : []
    const officedata = tempallofficedata

    //usercall/single user call
    const { getSingleOffice } = useGetofficesQuery('officelist', {
        selectFromResult: ({ data }) => ({
            getSingleOffice: data?.entities
        }),
    })

    // selcted office Id
    let selectedOfficeDoc = getSingleOffice && getSingleOffice[selectedOffice]
    let selectedOfficeBoId = selectedOfficeDoc?.Bo
    let selectedOfficeName = selectedOfficeDoc?.name
    let selectedBoDoc = getSingleuser && getSingleuser[selectedOfficeBoId]

    // option of office list
    let optionList = officedata?.map(elm => { return { value: elm._id, label: elm.name } })

    // add mutation call
    const [addNewRequest, { isLoading: addNewRequestloading }] = useAddNewassetReqMutation()

    //assets in transit status update call 
    const [updateAssetinTran, { isLoading: updateAssetinTranloading }] = useUpdateAssetintransitMutation()

    //in transit body 
    let selectedAssetarray = intSelected
    let assetTranBody = { selectedAssetarray: selectedAssetarray, transtatus: true }

    // create send to the assetmanager level-1 of the selected store
    let sendToOtherBoObj = { id: selectedOfficeBoId, name: getSingleuser && getSingleuser[selectedOfficeBoId]?.name, office: selectedOfficeName, designation: getSingleuser && getSingleuser[selectedOfficeBoId]?.designation[selectedOfficeName], designationSuffix: getSingleuser && getSingleuser[selectedOfficeBoId]?.designationSuffix[selectedOfficeName], numSuffix: getSingleuser && getSingleuser[selectedOfficeBoId]?.numSuffix[selectedOfficeName] }

    //************************************************************************ */
    //create a unique Id
    const uniqueReqID = () => {
        const dateString = Date.now().toString(36);
        const emailofuser = getSingleuser && getSingleuser[id]?.email?.slice(0, -8)
        const uid = `${emailofuser}-${dateString}`
        return uid;
    };
    let uniqueReqId = uniqueReqID()
    //****************************************************************************** */
    
    let userReqData = {
        uniqueReqId: uniqueReqId,
        req_type: 'ofc_to_ofc',
        req_cat: 'byBotoBo',
        req_creator: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        req_office: selectedOfficeName,
        req_store: "",
        sent_to_tag: 'bo',
        curr_status: 'pending',
        created_at: new Date(),
        curr_sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
        curr_sent_to: sendToOtherBoObj,
        req_data: [{
            // save all assets 
            assets_details: intSelected,
            Text: content,
            sent_by: { id: id, name: getSingleuser && getSingleuser[id]?.name, office: user_current_office, designation: designation[user_current_office], designationSuffix: designationSuffix[user_current_office], numSuffix: numSuffix[user_current_office] },
            sent_to: sendToOtherBoObj,
            status: 'pending',
            time_stamp: new Date()
        }]
    }

    const navigate = useNavigate();

    const handleReqSubmit = async () => {
        if (selectedOfficeBoId) {
            try {
                await addNewRequest(userReqData).unwrap()
                setContent('')
                setIntSelected([])
                await updateAssetinTran(assetTranBody)
                navigate('/management/assets/bo')
                return alert('your request is forwarded to the Branch officer of selected office')
            } catch (err) {
                return alert(`Error:${err}`)
            }
        } else {
            return alert('Bo in the office is not available. Please register Branch Officer')
        }
    }


    return (
        <Container>
            <Wrapper>
                <SelectContainer>
                    <Autocomplete
                        id="combo-box-demo"
                        options={optionList}
                        sx={{ width: 600 }}
                        value={selectedOffice}
                        onChange={(event, newValue) => {
                            if (newValue) {
                                // Set the selected value in state
                                setSelectedOffice(newValue.value);
                            } else {
                                // Handle case when no option is selected
                                setSelectedOffice(null);
                            }
                        }}
                        getOptionLabel={(option) => option.label}
                        renderInput={(params) => <TextField {...params} label="Please Select Office for Asset Transfer" />}
                    />
                </SelectContainer>
                <ReqWrapper>
                    {selectedOffice && <BoSpan> Details of Branch Officer of selected office:  {`${selectedBoDoc?.name.firstName} ${selectedBoDoc?.name.middleName} ${selectedBoDoc?.name.firstName}- ${selectedBoDoc?.designation[selectedOffice]}`}</BoSpan>}
                    <IntReqWrapper><EnhancedTable setIntSelected={setIntSelected} /></IntReqWrapper>
                    <TextInputWrap>
                        <HeadingWrap>
                            <Span>Details/Justifications</Span>
                        </HeadingWrap>
                        <JoditEditor
                            ref={editor}
                            value={content}
                            onBlur={newContent => setContent(newContent)}
                            onChange={newContent => { }}
                        />
                    </TextInputWrap>
                </ReqWrapper>
                <SubmitButton onClick={handleReqSubmit}>Sent to BO of selected office</SubmitButton>
            </Wrapper>
        </Container>
    )
}

export default OffToOffReq